export const paymentLabel = (status) =>
  ({
    awaiting_transfer: "Awaiting transfer",
    under_review: "Awaiting merchant confirmation",
    needs_attention: "Needs attention",
    partially_paid: "Partially paid",
    paid: "Paid",
    unpaid: "Unpaid",
    cancelled: "Cancelled",
  })[status] || status;
export const money = (minor) =>
  new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN" }).format(
    (minor || 0) / 100,
  );
export const paymentPath = (order) =>
  `${order.storeSlug ? `/${encodeURIComponent(order.storeSlug)}` : ""}/payment?orderId=${order._id}`;
export function orderAccess(orderId) {
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const token = fragment.get("access");
  if (token && orderId) {
    localStorage.setItem(`order-access:${orderId}`, token);
    window.history.replaceState(
      window.history.state,
      "",
      window.location.pathname + window.location.search,
    );
  }
  return {
    headers: {
      "x-order-access": localStorage.getItem(`order-access:${orderId}`) || "",
    },
  };
}
